export {
  default,
  type LeasingAcceptedOfferInterface
} from './leasing-accept-modal';
